import mixpanel from "mixpanel-browser";
import { useCallback } from "react";
import { MktVersionTypes } from "components/mkt/mktVersionUtils";

/**
 * Hook for sending Mixpanel events to the Promotion project only.
 * This is completely separate from the main Mixpanel instance.
 * No user identification needed as this is for anonymous onboarding tracking.
 */
export default function useMixpanelMKT(request: {
  params?: { [key: string]: string };
  eventName: string;
  version: MktVersionTypes;
}) {
  const params = request.params ? request.params : {};

  return useCallback(async () => {
    try {
      if (request.version === "v3") {
        const instance = (mixpanel as any).v3;
        if (instance) {
          instance.track(request.eventName, params);
        } else {
          console.warn("Mixpanel promotion instance not initialized");
        }
      } else if (request.version === "v4") {
        const instance = (mixpanel as any).promotion;
        if (instance) {
          instance.track(request.eventName, params);
        } else {
          console.warn("Mixpanel promotion instance not initialized");
        }
      } else if (request.version === "v5") {
        const instance = (mixpanel as any).v5;
        if (instance) {
          instance.track(request.eventName, params);
        } else {
          console.warn("Mixpanel promotion instance not initialized");
        }
      } else {
        return;
      }
    } catch (error) {
      console.error("error", error);
    }
  }, [request.version, request.eventName, params]);
}
